import React, { useState } from 'react';
import { BrowserRouter, Route, Routes, useNavigate, useParams,Navigate  } from 'react-router-dom';
import DefaultAppRoutes from './routes/defaultRoutes';
import AdminAppRoutes from './routes/AdminRoutes';
import { getStorageItem } from './utils/localStorage';
import { decodeToken } from 'react-jwt';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import routess from './routes/routes';
import { useSelector } from 'react-redux';
import fetchUserallowedRoutes from './hooks/fetchUserallowedRoutes';
import Unauthorized from './routes/pages/Unauthorized';
import NewSideBar from './components/Sidebar/NewSideBar';
import Navbar from './components/Navbars/Navbar';
import OrgNav from './components/Navbars/OrgNav';
import "./styles.css"


function RoutesFilter() {
  const navigate=useNavigate();
  let user = {};
  getStorageItem(`user`, (result) => {
    user = JSON.parse(result);
  });

  let allowed=[]
  allowed=fetchUserallowedRoutes(user.roleId).response;

  const loginuser = useSelector((state) => state.admin);
  let filteredRoutes=[]
  if(allowed){
 filteredRoutes= routess.filter(value => allowed.includes(value.path));
  }

if(user.userType==="A"){
  return (
    <div className='container-fluid pl-0'>
      {allowed&&loginuser?
 <div className='row'>
  {user.userType==="A"?<Navbar/>:<OrgNav/>}
  <div className='side-bar col-lg-2 col-md-12 col-sm-12 '>
  <NewSideBar/>
  </div>
  <div className='col-lg-9 col-md-12 col-sm-12 ml-4 '>
  <Routes>
    
    {filteredRoutes.map(({id,path,component})=>
    {
  
    return <>
    {window.location.pathname==="/"?user.userType==="A"?navigate("/dashboard/view"):navigate("/organization/dashboard"):" "}
    {path!=window.location.pathname?<Route path="*" element ={<Unauthorized/>} />:" "}
    <Route key={id} path={path} element ={component}/>
  
    </>
  
  })}
    
    {/* </Routes>:<div>No Routes Found</div> */}
   </Routes>
    </div>
  
 </div>:<div></div>}
</div>
  );
}
else{
  return (
    <div className='container-fluid pl-0'>
      {allowed&&loginuser?   
 <div className='row'>
  {user.userType==="A"?<Navbar/>:<OrgNav/>}
  <div className='side-bar col-lg-2 col-md-12 col-sm-12 '>
  <NewSideBar/>
  </div>
  <div className='col-lg-9 col-md-12 col-sm-12 ml-4 '>
  <Routes>
    
    {filteredRoutes.map(({id,path,component})=>
    {
   return <>
    {window.location.pathname==="/"?user.userType==="A"?navigate("/dashboard/view"):navigate("/organization/dashboard"):" "}
    {path!=window.location.pathname?<Route path="*" element ={<Unauthorized/>} />:" "}
    <Route key={id} styles={window.location.pathname===path?`${{backgroundColor:"red"}}`:" "} path={path} element ={component}/>
  
    </>
  
  })}
    
    {/* </Routes>:<div>No Routes Found</div> */}
   </Routes>
    </div>
  
 </div>:<div></div>}
</div>
  );



}

}

export default RoutesFilter;
